import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

export const createLaunchDarklyProvider = async (
  clientSideID: string,
  countryCode: string,
): Promise<
  ({ children }: { children: React.ReactNode }) => React.JSX.Element
> => {
  return await asyncWithLDProvider({
    clientSideID,
    context: {
      country: countryCode,
      key: 'myv-application-key',
      kind: 'user',
    },
    options: { bootstrap: 'localStorage' },
    timeout: 5,
  });
};
